export const LIST_COLUMNS = [
  { field: 'cnpj', headerName: 'CNPJ', align: 'left' },
  { field: 'razaoSocial', headerName: 'Razão Social', align: 'left' },
  { field: 'acoes', headerName: '', align: 'center' }
]
